import { createAsyncThunk } from '@reduxjs/toolkit';
import { OrderingConstants, OrderingOperations, OrderingSelectors } from 'polygon-ordering';

const { getSelectedPaymentMethods } = OrderingSelectors;
const { updateSelectedPaymentMethod } = OrderingOperations;
const { PAYMENT_METHOD } = OrderingConstants;

const PAYMENT_GATEWAY_METHODS = [PAYMENT_METHOD.CREDIT_CARD, PAYMENT_METHOD.SAVED_CARD];

export const applyTokenToGatewayPaymentMethod = createAsyncThunk(
  'applyTokenToGatewayPaymentMethod',
  async (data: { token?: string; lastFour?: string }, { dispatch, getState }) => {
    const { token, lastFour } = data;

    const gatewayMethod = getSelectedPaymentMethods(getState() as EntireFrontendState).find(
      method => PAYMENT_GATEWAY_METHODS.includes(method.method),
    );

    if (!gatewayMethod) {
      return;
    }

    dispatch(updateSelectedPaymentMethod({ ...gatewayMethod, token, lastFour }));
  },
);
